import { useState } from 'react'
import './Header.css'

export function Header ({ activeItem }) {
  const [menuVisible, setMenuVisible] = useState(false)

  function toggleMenu () {
    setMenuVisible(!menuVisible)
  }

  return (
    <header>
      <nav className='main-nav'>
        <div className='container nav-container'>
          <a href='/' className='brand-name cormorant-sc-light'>
            FERN AND FABLE
          </a>
          <button className='hamburger' aria-label='Menu' onClick={toggleMenu}>
            <div className='hamburger-lines'>
              <span className='hamburger-line'></span>
              <span className='hamburger-line'></span>
              <span className='hamburger-line'></span>
            </div>
          </button>
          <ul className={'nav-links ' + (menuVisible ? 'active' : '')}>
            <li>
              <a
                href='book'
                className={activeItem === 'book' ? 'cta-button' : ''}
              >
                Book Now
              </a>
            </li>
            <li>
              <a
                href='themes'
                className={activeItem === 'themes' ? 'cta-button' : ''}
              >
                Themes
              </a>
            </li>
            <li>
              <a
                href='pricing'
                className={activeItem === 'pricing' ? 'cta-button' : ''}
              >
                Pricing
              </a>
            </li>
            <li>
              <a
                href='contact'
                className={activeItem === 'contact' ? 'cta-button' : ''}
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  )
}
